import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Card, Divider, Button } from 'antd'
import '../../css/regimen.scss'
import { useLocation } from 'react-router'
import moment from 'moment'
import { constants } from '../../constants'
import serviceInterface from '../../services/service.interface'
import { assignRegimens } from '../../store/action/regimen.action'
import { getHelp, pages } from '../../tutorials'

const RegimenCard = (props) => {
  var location = useLocation()

  var patient = location.state?.patient

  useEffect(() => {
    getHelp(pages.ASSIGNREGIMEN)
  }, [])
  var handleAssignClick = (e) => {
    var regs = serviceInterface
      .RegimenServide()
      .assignRegimen(props.regimen, props.assignedRegs)
    props.assignRegimen(regs)
  }

  var renderHeader = () => (
    <Row className='cardHeader' align='middle'>
      <Col>
        <h3>{props.regimen?.name}</h3>
      </Col>
      <Col hidden={props.hideBtn} style={{ marginLeft: 'auto' }}>
        <Button
          className='assignBtn'
          disabled={props.assigned}
          onClick={handleAssignClick}
        >
          {props.assigned ? 'Assigned' : 'Assign'}
        </Button>
      </Col>
    </Row>
  )

  var renderExercises = () => {
    return props.regimen
      ? props.regimen.exerciseschedule.map(
          ({
            hold,
            repeat,
            time,
            set,
            startdate,
            enddate,
            exercise: { image, name },
          }) => {
            var sd = moment(patient?.surgery?.date)
              .add(startdate, 'd')
              .format('MM/DD/YYYY')
            var ed = moment(patient?.surgery?.date)
              .add(enddate, 'd')
              .format('MM/DD/YYYY')
            var showRepeat = !(time && parseInt(time) > 1)
            return (
              <Row className='exerRow' align='middle'>
                <Col>
                  <div className='exerImgBox'>
                    <img className='exerImg' src={constants.API_URL + image} />
                  </div>
                </Col>
                <Col>
                  <Row className='exerHeader'>{name}</Row>
                  <Row className='exerDescp'>
                    <Col>
                      <Row>
                        {'S' +
                          (startdate >= 0
                            ? '+' + startdate.toString()
                            : startdate.toString())}
                        &nbsp;to&nbsp;
                        {'S' +
                          (enddate >= 0
                            ? '+' + enddate.toString()
                            : enddate.toString())}
                      </Row>
                      <Row>
                        {sd} - {ed}
                      </Row>
                      <Row>
                        <Col>
                          <span hidden={!hold && !repeat}>
                            {hold ? `Hold ${hold}. ` : ''}
                            {repeat ? ` Repeat ${repeat} times.` : ''}
                            {set
                              ? ` ${set} set at a time${!showRepeat ? ', ' : '. '}`
                              : ''}
                          </span>
                          <span hidden={showRepeat}>
                            {`${parseInt(time) == 1 ? 'once' : time + ' times'}  a day.`}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )
          }
        )
      : null
  }

  return (
    <Card
      id={'selectregimen'}
      bordered={false}
      title={!props.hideHeader ? renderHeader() : null}
      className='regimenCard'
    >
      <Row className='dateHeader divide'>EXERCISES</Row>
      <Row>
        <Col style={{ width: '100%' }}>{renderExercises()}</Col>
      </Row>
    </Card>
  )
}

RegimenCard.propTypes = {
  company: PropTypes.object,
  regimen: PropTypes.object,
  assigned: PropTypes.bool,
  hideBtn: PropTypes.bool,
  hideHeader: PropTypes.bool,
  assignedRegs: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {
    company: state.profile.company,
    assignedRegs: state.regimen.assignedRegs,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    assignRegimen: (regimens) => dispatch(assignRegimens({ regimens })),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegimenCard)
